const firstFiniteNumber = (...values) => {
  for (const value of values) {
    if (value === undefined || value === null || value === "") {
      continue;
    }
    const number = Number(value);
    if (Number.isFinite(number)) {
      return number;
    }
  }
  return undefined;
};

const getNestedValue = (order, key) =>
  order?.[key] ?? order?.booking?.[key] ?? order?.order?.[key] ?? order?.trip?.[key];

export const formatPassengerLuggage = (order = {}) => {
  const passengerCount = firstFiniteNumber(
    getNestedValue(order, "passenger_count"),
    getNestedValue(order, "passengerCount"),
    getNestedValue(order, "passengers"),
    getNestedValue(order, "passenger"),
    getNestedValue(order, "guest_count"),
    getNestedValue(order, "number_of_passengers"),
    getNestedValue(order, "people_count"),
  );
  const luggageCount = firstFiniteNumber(
    getNestedValue(order, "luggage_count"),
    getNestedValue(order, "luggageCount"),
    getNestedValue(order, "luggage"),
    getNestedValue(order, "bag_count"),
    getNestedValue(order, "bags"),
    getNestedValue(order, "baggage_count"),
    getNestedValue(order, "suitcase_count"),
    getNestedValue(order, "number_of_luggage"),
  );

  if (passengerCount === undefined && luggageCount === undefined) {
    return "0人 / 0件";
  }
  if (passengerCount === undefined) {
    return `0人 / ${luggageCount}件`;
  }
  if (luggageCount === undefined) {
    return `${passengerCount}人 / 0件`;
  }

  return `${passengerCount}人 / ${luggageCount}件`;
};
